<template>
  <div class="bigloader">
    <v-progress-circular class="centered" indeterminate></v-progress-circular>
  </div>
</template>
<script>
export default {};
</script>
<style>
.bigloader {
  width: 100vw;
  height: 100vh;
}
.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}
</style>
